import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, View, Waiting } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import {
  addVehicleToBulkActionsList,
  assignVehicleTransport,
  completeVehicleTransport,
  deleteVehicleProperty,
  removeVehicleFromBulkActionsList,
  setVehicleProperties,
  setVehicleProperty,
} from '../../../Vehicles/actions';
import { refreshBoards } from '../../actions';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { FormField } from '../../../../components/FormFields';
import { Dropdown } from '../../../../components/Dropdown';
import { HBox, VBox } from '../../../../components/Box';
import { TransportAssignableOptions, TransportAssignableSortMap } from './Transport_1_nl_in';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { formatLicensePlate } from '../../../../utils/string';
import { AddressFields } from '../../../Address/components/AddressFields';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './Transport.module.css';
import cn from 'classnames';
import { REQUEST_COMPANIES_PROPERTY } from '../../../Companies/constants';
import { selectCompanyProperty } from '../../../Companies/selectors';
import { selectAddress } from '../../../Address/selectors';
import { REQUEST_ADDRESSES_BY_IDS } from '../../../Address/constants';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { selectVehicleBulkActionsList } from '../../../Vehicles/selectors';
import { Checkbox } from '../../../../components/Checkbox';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const Container = styled.div`
  .modal-inner {
    margin-bottom: 120px;
  }
  .red-text {
    color: red;
  }
  p {
    margin: 0;
  }

  .col-regplate-vin {
    max-width: 200px;
  }

  .col-model-info {
    min-width: 100px;
    max-width: 100px;
  }

  .col-address-from {
    min-width: 250px;
    max-width: 250px;
  }

  .col-address-to {
    min-width: 200px;
    max-width: 200px;
  }

  .regplate {
    font-size: 14px;
  }
  font-size: 12px;
`;

const STATE = {
  approve: false,
  selected: null,
  loading: false,
};

/* eslint-disable react/prefer-stateless-function */
class IDWE_transport_nl_out_combinedComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
    this.state = {
      selected: null,
    };
  }

  setStateFn = newState => () => {
    this.setState(newState);
  };
  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  get action() {
    return this.props.action;
  }

  get bulkActionsList() {
    let list = [];
    if (this.props.bulkActionsList?.length) {
      list = this.props.bulkActionsList;
    }
    return list;
  }

  isSelectedVehicle() {
    return this.bulkActionsList?.filter(item => item?.id == this.vehicle?.id)?.length == 1;
  }

  onSelectVehicle(e, vehicle) {
    e.stopPropagation();
    if (this.isSelectedVehicle(vehicle?.id)) {
      return this.props.removeVehicleFromBulkActionsList(vehicle?.id);
    }

    return this.props.addVehicleToBulkActionsList(vehicle, this.action.functionName);
  }

  static transportAssignableSortMap = TransportAssignableSortMap;

  renderApprove() {
    const vehicle = this.vehicle;
    if (this.props.work) return null;

    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <>
        <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.Transport_1_nl_out.modal.title')}>
          <row>
            <VBox vCenter>
              <VBox className="regplate col-regplate-vin">
                <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
                <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>
              </VBox>
              <VBox className="col-model-info">
                <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
                <p>{vehicle.model_name}</p>
              </VBox>

              <VBox left className="address col-address-to">
                <div className="mb-1">
                  <CompanyLabelById fetchName company_id={vehicle.transport_outgoing_to_company_id} />
                </div>
                <div className="mb-1">
                  <AddressFields
                    inlineshort
                    addressId={vehicle.transport_outgoing_to_address_id}
                    company_id={vehicle.transport_outgoing_to_company_id}
                  />
                  <CompanyLabelById fetchPhone company_id={vehicle.transport_outgoing_to_company_id} />{' '}
                </div>
                <div className="mb-1">
                  <CompanyLabelById fetchPhone company_id={vehicle.transport_outgoing_to_company_id} />
                </div>
              </VBox>
              <VehicleStatusLabel color="#0183D5">out</VehicleStatusLabel>
            </VBox>
            {this.state.selected === '1' && (
              <div>
                <VehiclePropertyEditableInput propertyName="transporter_extern" vehicle_id={this.vehicle.id} />
              </div>
            )}
          </row>

          <div className={styles.buttonGrid}>
            {TransportAssignableOptions.map(a => (
              <Button
                className={styles.buttonItem}
                primary={a.value == this.state.selected}
                key={a.label}
                onClick={this.setStateFn({ selected: a.value })}
              >
                {a.label.replace(/\_/g, ' ')}
              </Button>
            ))}
          </div>

          <div className="d-flex gap-2 mt-2">
            {this.props.work || this.state.loading ? (
              <Loader small />
            ) : (
              <>
                <ButtonComponent
                  style={'ButtonSoftEdit'}
                  onClick={() => {
                    this.setState({ loading: true });
                    this.props.assign(this.state.selected, this.reset.bind(this));
                  }}
                >
                  {this.lbl('save')}
                </ButtonComponent>
                <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
                  {this.lbl('cancel')}
                </ButtonComponent>
              </>
            )}
          </div>
        </ModalComponent>
      </>
    );
  }

  render() {
    const vehicle = this.vehicle;
    const tasks = [
      'task_desticker',
      'task_nijboer',
      'task_attach_parts',
      'task_AVN',
      'task_polish_exterior',
      'task_interior_polish',
      'task_interior_repair',
      'task_int_ext_polish',
      'task_restyle',
      'task_spot_repair',
      'task_spray',
      'task_window_repair',
      'task_repair',
      'task_apk',
      'task_hartstad',
      'task_ijsseldelta',
    ];

    const vehicleTasks = tasks.filter(task => ['1', '2', '3'].includes(vehicle[task]));

    return (
      <Cell className={styles.cell}>
        <Container onClick={this.setStateFn({ approve: !this.state.approve })}>
          {this.props.cell.busy ? <Loader small /> : null}
          <HBox vCenter>
            <Checkbox checked={this.isSelectedVehicle()} onChange={e => this.onSelectVehicle(e, vehicle)} />
            <VBox left className="regplate col-regplate-vin">
              <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
              <span style={{ opacity: 0.4 }}>({vehicle.vin || ''})</span>
              {vehicle?.location_address_id == '5' ? (
                ''
              ) : (
                <span className="red-text">{this.lbl('kanbanboards.cell.not_home')}</span>
              )}
              {vehicleTasks.length > 0 ||
              (vehicle.task_attach_replate === '1' && vehicle.task_attach_replate_done === null) ? (
                <span className="red-text">{this.lbl('kanbanboards.cell.has_open_task')}</span>
              ) : (
                ''
              )}
            </VBox>
            <VBox left className="col-model-info">
              <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
              <p>{vehicle.model_name}</p>
            </VBox>

            <VBox left className="address col-address-to">
              {this.props.companyName && (
                <CompanyLabelById fetchName company_id={vehicle.transport_outgoing_to_company_id} />
              )}{' '}
              {(this.props.address || this.props.loadSingleRes) && (
                <AddressFields inlineshort addressId={vehicle.transport_outgoing_to_address_id} />
              )}
              <div className="mb-1">
                <CompanyLabelById fetchPhone company_id={vehicle.transport_outgoing_to_company_id} />
              </div>
            </VBox>
            <VehicleStatusLabel color="blue">out</VehicleStatusLabel>
            <Label count={vehicle?.transportuitgaandintern} ranges={ranges}>
              {vehicle?.transportuitgaandintern || '0'}
            </Label>
          </HBox>
        </Container>
        {this.renderApprove()}
        <HBox style={{ fontSize: '12px' }} onClick={this.tofn(`/vehicles/${vehicle.id}`)}>
          {vehicle.id}{' '}
        </HBox>
      </Cell>
    );
  }
}

IDWE_transport_nl_out_combinedComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_COMPANIES_PROPERTY,
      REQUEST_ADDRESSES_BY_IDS,
    ]),
    companyName: selectCompanyProperty(ownProps.cell.vehicle.transport_outgoing_to_company_id, 'name'),
    address: selectAddress(ownProps.cell.vehicle.transport_outgoing_to_address_id),
    bulkActionsList: selectVehicleBulkActionsList(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    //
    assign(id, callback) {
      dispatch(
        assignVehicleTransport(ownProps.cell.vehicle.id, id + '', true, false, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
    done(callback) {
      let id = ownProps.cell.vehicle.id;
      const action_name = ownProps.action.functionName;
      dispatch(
        completeVehicleTransport(id, true, false, action_name, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
    addVehicleToBulkActionsList(vehicle, kanbanTaskName) {
      dispatch(addVehicleToBulkActionsList(vehicle, [], kanbanTaskName));
    },
    removeVehicleFromBulkActionsList(vehicleId) {
      dispatch(removeVehicleFromBulkActionsList(vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const IDWE_transport_nl_out_combined = compose(withConnect, withRouter)(IDWE_transport_nl_out_combinedComp);
